// FT-192 (REQ-08): готовые подкатегории-подсказки вкладки настроек «Статьи платежей».
// Ключ — код статьи (MoneyGroups), значение — ключи локали count_categories_tab.presets.*.
// Чип ничего не создаёт сам: клик отправляет POST с текстом на языке пользователя.
export const COUNT_CATEGORY_PRESETS = {
  common_expences: ["communication", "software", "stationery", "cleaning", "legal_accounting", "bank_fees"],
  transport_expences: ["taxi", "parking", "tow_truck"],
  other_expense: ["bank_fees", "client_refunds"],
  office_expences: ["utilities", "warehouse"],
  ads_expences: ["online_ads", "print_ads"],
};

export function presetKeysFor(code) {
  return COUNT_CATEGORY_PRESETS[code] || [];
}

export const PRESET_LOCALE_KEYS = Array.from(
  new Set(Object.values(COUNT_CATEGORY_PRESETS).reduce((all, keys) => all.concat(keys), []))
).map((key) => `count_categories_tab.presets.${key}`);
